import { FETCH_ALL_PARAMS } from 'constants/query';
import { useGetProductCategoriesQuery } from 'features/product-category/services';
import { useMemo } from 'react';
import { ProductCategoriesColumns, useProductCategoryTableColumns } from '../constants/table-settings';
import { configureTableColumns } from 'utils/table-helpers';
import { useProductCategoryStatus } from '../constants/status';
import useTable from 'hooks/useTable';

const useController = () => {
    const { data: productCategories } = useGetProductCategoriesQuery(FETCH_ALL_PARAMS);
    const PRODUCT_CATEGORY_STATUS = useProductCategoryStatus();

    const filterSelectOptions = useMemo(() => {
        if (!productCategories) return;

        return {
            isActive: [
                { value: 'true', label: PRODUCT_CATEGORY_STATUS.ACTIVE },
                { value: 'false', label: PRODUCT_CATEGORY_STATUS.INACTIVE },
            ],
        };
    }, [productCategories, PRODUCT_CATEGORY_STATUS]);

    const { tableSettings } = useTable<ProductCategoriesColumns>({
        columns: configureTableColumns(useProductCategoryTableColumns(), filterSelectOptions || {}),
        queryIdentifier: 'productCategories',
    });

    return {
        tableSettings,
    };
};

export default useController;
